<div id="newLogoContent" class="tab-pane active">
  <div class="tab-content" id="newPromoTabs-content">
    <form [formGroup]="priceContentgrpForm">
      <div id="priceContentRow" class="row">
        <div id="priceContentCol" class="col-md-4 justify-content-start">
          <div id="priceContentFormGrp" class="form-group ">
            <label for="publishedName">
              <span i18n="@@global.tab-text.published-name">Published Name</span>
              <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" id="publishedName" placeholder="{{publishednamePlaceHolderText}}"
              formControlName="publishedName" name="publishedName" maxlength="50" required />
            <div id="priceContentSubmittedName" *ngIf="isSubmitted && priceContentgrpForm?.controls?.publishedName?.value === ''" class="formfield_err_msg">
              <span i18n="@@create-price-content.priceContentgrpForm.required-field">This is a required field.</span>
            </div>
            <div id="priceContentSubmittedMax" *ngIf="isSubmitted && priceContentgrpForm?.controls?.publishedName?.errors?.maxlength" class="formfield_err_msg">
              <span i18n="@@create-price-content.priceContentgrpForm.published-name-long">Published name may be up to 50 characters long.</span>
            </div>
          </div>
          <div id="internalNameFormGrp" class="form-group">
            <label for="internalName">
              <span i18n="@@global.tab-text.internal-name">Internal Name</span>
            </label>
            <input type="text" class="form-control" id="internalName" placeholder="{{internalnamePlaceHolderText}}"
              formControlName="internalName" maxlength="50" />
          </div>
        </div>
        <div id="publishedTimeStamp" class="justify-content-start" [ngClass]="(isPublishDateCustomDatepicker || isExpiryDatePicker) ? 'col-md-8 pl-5 logo_vertical_border' : 'col-md-3 pl-5 logo_vertical_border'">
          <div class="form-group">
            <!-- TODO-->
            <!-- <label for="publishedTimeStamp">Publish Date & Time<span class="text-danger">*</span></label>
            <div container="body" [ngbPopover]="dateTimePicker" placement="bottom-right" [autoClose]="false"
              popoverTitle="Publish Date/Time">
              <input class="form-control" value="{{dateTimeValue}}" formControlName="publishedTimeStamp"
                id="publishedTimeStamp">
              <em class="date_icon cursor-pointer"></em>
            </div>
            <em class="err_icon"></em>
            <div *ngIf="isSubmitted && isPublishedDateInCorrect" class="formfield_err_msg">Published date should not be
              less than today </div>
            <span class="formfield_err_msg"></span>
            <ng-template #dateTimePicker>
              <iposcen-datetimepicker-popover (currentDateTime)="getPublishDate($event)"
                (selectedDateTime)="getPublishSelectedTime($event)" popoverTitle="Publish"
                buttonText="Use Current Date & Time">
              </iposcen-datetimepicker-popover>
            </ng-template> -->
            <label for="publishedTimeStamp">
              <span i18n="@@create-price-content.priceContentgrpForm.published-date-time">Publishing Date and Time</span>
            </label>
            <div id="publishDateSection" class="publishDate-Section">
              <div id="publishDateRadio">
                <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                  [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')" />
                <label for="now">
                  <span i18n="@@create-price-content.priceContentgrpForm.now">Now</span>
                </label>
              </div>
              <div id="publishDateCustomDatepicker" class="custom-datepicker">
                <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
                  id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
                  (click)="selectCustomPublishDate('custom')" />
                <label for="publish-date-custom" [ngClass]="{'custom-picker-label':isRussian}" *ngIf="!isPublishDateCustomDatepicker" i18n="@@create-price-content.custom-datepicker.custom">Custom</label>
                <div id="PublishDateCustomDatepickerTimeZone" *ngIf="isPublishDateCustomDatepicker">
                  <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')" (getDateTimeZoneData)="getLogoContentPublishDate($event)"
                  (isTimeZoneSelected)="checkTimeZone($event,'publish')" [publishDateInfo]="editPublishDateInfo">
                  </iposcen-date-time-zone>
                </div>
              </div>
              <div id="CustomPublishDateCorrect" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg">
                <span i18n="@@create-price-content.priceContentgrpForm.now">Please select the publishing date and time zone</span>
              </div>
            </div>
          </div>
          <div id="expiryTimeStampFormGrp" class="form-group">
            <!-- TODO-->
            <!-- <label for="expiryTimeStamp">Expiration Date & Time<span class="text-danger">*</span></label>
            <div container="body" [ngbPopover]="dateTimePickereExpiry" placement="top-right" container="body"
              [autoClose]="false" popoverTitle="Expiry Date/Time">
              <input class="form-control" value="{{expiryDateTime}}" formControlName="expiryTimeStamp"
                id="expiryTimeStamp">
              <em class="date_icon cursor-pointer"></em>
              <div *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"> Expiry should not be less than published date
              </div>
            </div>
            <em class="err_icon"></em>
            <span class="formfield_err_msg"></span>
            <ng-template #dateTimePickereExpiry>
              <iposcen-datetimepicker-popover (currentDateTime)="getExpiryNever($event)"
                (selectedDateTime)="getExpirySelectedTime($event)" popoverTitle="Expiry" buttonText="Expire Never">
              </iposcen-datetimepicker-popover>
            </ng-template> -->
            <label for="publishedTimeStamp">
              <span i18n="@@create-price-content.publishedTimeStamp.expiry-date-time">Expiration Date and Time</span>
            </label>
            <div id="expiryDateSection" class="publishDate-Section">
              <div id="expiryDateRadio">
                <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                  [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
                <label for="never">
                  <span i18n="@@create-price-content.publish-date.never">Never</span>
                </label>
              </div>
              <div id="expiryCustomeDatePicker" class="custom-datepicker">
                <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
                  [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
                <label [ngClass]="{'custom-picker-label':isRussian}" for="expiry-custom" *ngIf="!isExpiryDatePicker">
                  <span i18n="@@create-price-content.custom-datepicker.custom">Custom</span>
                </label>
                <div id="expiryDatePickerTimeZone" *ngIf="isExpiryDatePicker">
                  <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')" (getDateTimeZoneData)="getLogoContentExpiryDate($event)"
                  (isTimeZoneSelected)="checkTimeZone($event,'expiry')" [expiryDateInfo]="editexpiryDateInfo">
                  </iposcen-date-time-zone>
                </div>
              </div>
              <div id="expiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg">
                <span i18n="@@create-price-content.custom-datepicker.expiry-less-than-publish">Expiration date should not be before publishing date.</span>
              </div>
              <div id="customExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg">
                <span i18n="@@create-price-content.custom-datepicker.please-select-expiry-date-time">Please select expiration date and time zone.</span>
              </div>
            </div>
          </div>
        </div>
        <!-- IIT2-4654 -->
        <div id="PublishDateCustomDatepickerCol" [ngClass]="(!isPublishDateCustomDatepicker && !isExpiryDatePicker) ? 'col-md-5 pl-5' : 'col-md-6'">
          <label for="" i18n="@@create-banner-carousel.tab-pane.apply-to-content">Apply content group to</label>
          <button type="button" class="btn btn-primary btn-sm left_icon_btn gtmFormFctrBanner"
            (click)="openFormFactorsModal()">
            <img class="laptop_icon_formFactor" alt="select form factors" />
            <span i18n="@@create-banner-carousel.select-form-factor">Select Form Factors</span>
          </button>
          <iposcen-form-factors #formFactorsModal [contentName]="selectedFormFactors"
            (applyFormFactor)="applyFormFactor($event)"></iposcen-form-factors>
          <div id="selectedFormFactors" *ngIf="selectedFormFactors" class="selected_factors">
              <div  id="applyFormFactorDevicesSection">
                <div id="applyFormFactorDeviceTypes" class ="font-bold inline-block"><span>{{deviceTypes}}</span>: </div>
                <div  id="selectedFormFactorsdevices" class="inline">&nbsp;<span>{{ selectedFormFactors?.devices}} </span></div>
              </div>
              <div id="applyFormFactorManufacturesSection">
                <div  id="applyFormFactorManufactures" class ="font-bold inline-block"><span>{{manufacturers}}</span>: </div>
                <div id="selectedFormFactorsManufactures" class="inline">&nbsp;<span>{{ selectedFormFactors?.manufacturer}} </span></div>
              </div>
              <div id="applyFormFactorProcessorsSection">
                <div id="applyFormFactorProcessors" class ="font-bold inline-block"><span>{{processors}}</span>: </div>
                <div id="selectedFormFactorsProcessors" class="inline">&nbsp;<span>{{ selectedFormFactors?.processors}}</span></div>
              </div>
              <div id="applyFormFactorGenerationSection">
                <div id="applyFormFactorGeneration" class ="font-bold inline-block"><span>{{generation}}</span>: </div>
                <div  id="selectedFormFactorsGeneration" class="inline">&nbsp;<span>{{ selectedFormFactors.generations}}</span></div>
              </div>
          </div>
        </div>
      </div>
      <!-- IIT2-4654 end-->
    </form>
  </div>
  <div id="btnWrapper" class="button-wrapper" style="justify-content: flex-end">
    <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmCancelPrice">
      <span i18n="@@create-price-content.tab-pane.cancel">Cancel</span>
    </button>
    <button type="button" (click)="onAdd()" class="btn btn-primary gtmSavePrice"
      [disabled]="!priceContentgrpForm?.controls?.publishedName?.value.trim()">
      <span class="gtmSavePrice" i18n="@@create-price-content.tab-pane.save-and-proceed">Save and Proceed</span>
    </button>
  </div>
</div>
